module.exports = __webpack_public_path__ + "static/media/Nespresso.41952735.png";